import { useEffect } from "react";
import { Check, TriangleAlert } from "lucide-react";
import { LINKS } from "../data";
import "../App.css";

const EMAIL = "info.agaespanol@gmail.com";

const ITEMS = [
  "Powieść „Un nuevo comienzo” PDF (30 rozdziałów A1/A2)",
  "Audiobook nagrany przez rodowitą Hiszpankę (MP3)",
  "Zeszyt ćwiczeń z kluczem odpowiedzi (PDF)",
  "Tłumaczenia na polski i słowniczki",
  "Kalendarz czytania na 30 dni",
];

function trackPurchase() {
  if (!window.fbq) return;
  if (!sessionStorage.getItem("purchase_fired_dziekuje")) {
    window.fbq("track", "Purchase", { value: 55, currency: "EUR" });
    sessionStorage.setItem("purchase_fired_dziekuje", "1");
  }
}

export default function ThankYou() {
  useEffect(() => {
    document.title = "Dziękujemy! — Un nuevo comienzo";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    trackPurchase();
    return () => meta.remove();
  }, []);

  return (
    <div className="lp" data-testid="thank-you-page">
      <main className="lp-wrap lp-ty">
        <section className="lp-ty-hero">
          <h1 className="lp-title" data-testid="ty-title">Dziękujemy! Twój dostęp jest gotowy 🎉</h1>
          <p className="lp-sub" data-testid="ty-subtitle">Płatność zakończona sukcesem. Pobierz materiały poniżej.</p>
          <a
            className="lp-btn lp-ty-btn"
            href={LINKS.download}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ty-download-button"
          >
            POBIERZ EBOOK + AUDIOBOOK + ĆWICZENIA
          </a>
          <p className="lp-trust" data-testid="ty-download-note">
            Dostęp bezterminowy • Pliki PDF + MP3 • Możesz pobrać od razu na telefon i komputer
          </p>
        </section>

        <div className="lp-ty-warn" data-testid="ty-bookmark-warning">
          <TriangleAlert size={22} />
          <p>
            <strong>Zapisz tę stronę w zakładkach!</strong> To jedyne miejsce z dostępem. Jeśli zamkniesz okno,
            wrócisz tu przez ten sam link. W razie problemów napisz: <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
          </p>
        </div>

        <section className="lp-card" data-testid="ty-contents">
          <h2 className="lp-card-h">Co otrzymujesz</h2>
          <ul className="lp-list">
            {ITEMS.map((x, i) => (
              <li key={i}><Check size={20} /> <span>{x}</span></li>
            ))}
          </ul>
        </section>

        <p className="lp-ty-help" data-testid="ty-help">
          <strong>Co jeśli link nie działa?</strong> Napisz na <a href={`mailto:${EMAIL}`}>{EMAIL}</a> — odpowiem w 24h.
        </p>
      </main>
    </div>
  );
}
